<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row
      class="justify-center mb-3 mx-2"
      style="background-color: #ffffff; border-radius: 8px"
    >
      <v-col cols="5" sm="6" md="4" class="px-0">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="from_date"
              :label="$t('startDate')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            :color="site.color"
            no-title
            scrollable
            v-model="from_date"
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="1" class="text-center px-0"
        ><p class="mb-0 mt-2">-</p>
      </v-col>
      <v-col cols="5" sm="6" md="4" class="px-0">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              v-model="to_date"
              :label="$t('endDate')"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            :color="site.color"
            no-title
            scrollable
            v-model="to_date"
            @input="endDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row class="px-2">
      <v-col
        v-for="(item, index) in listData"
        :key="index"
        cols="12"
        class="py-1"
      >
        <v-sheet style="border-radius: 8px">
          <v-card
            elevation="0"
            :color="colorCard(item.status)"
            style="border-radius: 8px"
          >
            <v-card-title class="py-1 px-1">
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <p class="text-body-2 mb-1">
                      {{ item.name }}
                    </p>
                    <p class="text-caption mb-0" style="line-height: 1.4">
                      {{ $t("code") }} : {{ item.code }}
                      <br />
                      {{ $t("status") }} : {{ item.status_label }}
                      <br />
                      {{ $t("date") }} : {{ item.created_at | checkExpire }}
                    </p>
                    <p
                      class="text-caption mb-0 mt-1"
                      v-if="item.user && item.user.length != 0"
                    >
                      <v-avatar
                        size="20"
                        class="mr-1"
                        style="background-color: black"
                      >
                        <v-img
                          :src="
                            item.user.image_path
                              ? item.user.image_path
                              : defaultImage
                          "
                        ></v-img>
                      </v-avatar>
                      <span class="mt-1" style="font-style: italic">
                        {{ item.user.name }} {{ item.user.surname }}
                      </span>
                    </p>
                  </v-col>
                  <v-col
                    cols="4"
                    class="px-0 pr-2 d-flex flex-column justify-center align-end"
                  >
                    <div class="d-flex align-center">
                      <p
                        class="text-body-1 mb-0"
                        style="font-weight: 600"
                        :style="{
                          color: colorPoint(item.status),
                        }"
                      >
                        {{
                          item.point > 0 ? `+${item.point} ` : `${item.point} `
                        }}
                      </p>
                      <div class="ml-1">
                        <PointSymbol
                          :type="item.point_type_type"
                          :symbol="item.point_type_symbol"
                          :color="item.point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="28"
                        />
                      </div>
                    </div>
                    <div
                      class="text-body-2 text-end"
                      style="font-weight: 600"
                      :style="{
                        color: colorPoint(item.status),
                      }"
                    >
                      {{ item.point_type_name }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!listData.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import moment from "moment";
import HeaderTextBg from "@/components/headerTextBg.vue";
import { blendColorWithWhite } from "../../../config/general-function";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  name: "HistoryCode",
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    InfiniteLoading,
    PointSymbol,
  },

  data() {
    return {
      drawer: false,
      from_date: new Date(
        new Date().setDate(new Date().getDate() - 30) -
          new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      to_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      listData: [],
      startDateMenu: false,
      endDateMenu: false,

      next_page_url: "",
      infiniteId: +new Date(),
      title: "",
    };
  },
  created() {
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "history-code");
    this.title = model?.name;
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },
  beforeMount() {},

  methods: {
    colorCard(status) {
      let themeColor = this.site.color || "#f2c00e";
      if (status == "สำเร็จ") {
        themeColor = this.site.color || "#f2c00e";
      } else if (status == "ไม่พบรหัส") {
        themeColor = "#ff0000";
      } else {
        themeColor = "#f2c00e";
      }
      themeColor = blendColorWithWhite(themeColor, 0.2);
      return themeColor;
    },
    colorPoint(status) {
      let themeColor = this.site.color || "#f2c00e";
      if (status == "สำเร็จ") {
        themeColor = this.site.color || "#f2c00e";
      } else if (status == "ไม่พบรหัส") {
        themeColor = "#ff0000";
      } else {
        themeColor = "#f2c00e";
      }
      return themeColor;
    },
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get(`point/getHistoryCode`, {
        params: {
          from_date: this.from_date,
          to_date: this.to_date,
          page: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (Array.isArray(data?.data?.data)) {
            let has_more = data.data.has_more;
            this.listData = this.listData.concat(data.data.data);
            if (!has_more) {
              // $state.complete();
              // return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
  watch: {
    to_date: {
      handler() {
        this.listData = [];
        this.next_page_url = "";
        this.infiniteId += 1;
      },
      deep: true,
    },
    from_date: {
      handler() {
        this.listData = [];
        this.next_page_url = "";
        this.infiniteId += 1;
      },
      deep: true,
    },
  },
  filters: {
    checkExpire(value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm");
      } else {
        label = date.format("DD MMM YY, HH:mm");
      }
      return label;
    },
  },
};
</script>

<style scoped>
</style>
